export const iconFontAwesomeMathematicsSquareRootVariable = (
	<i className="fa-solid fa-square-root-variable"></i>
);
